/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreightClaimRepairability = {
    Repairable: 'Repairable',
    NotRepairable: 'NotRepairable',
    Unknown: 'Unknown'
} as const;
export type FreightClaimRepairability = typeof FreightClaimRepairability[keyof typeof FreightClaimRepairability];


export function instanceOfFreightClaimRepairability(value: any): boolean {
    for (const key in FreightClaimRepairability) {
        if (Object.prototype.hasOwnProperty.call(FreightClaimRepairability, key)) {
            if (FreightClaimRepairability[key as keyof typeof FreightClaimRepairability] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreightClaimRepairabilityFromJSON(json: any): FreightClaimRepairability {
    return FreightClaimRepairabilityFromJSONTyped(json, false);
}

export function FreightClaimRepairabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreightClaimRepairability {
    return json as FreightClaimRepairability;
}

export function FreightClaimRepairabilityToJSON(value?: FreightClaimRepairability | null): any {
    return value as any;
}

export function FreightClaimRepairabilityToJSONTyped(value: any, ignoreDiscriminator: boolean): FreightClaimRepairability {
    return value as FreightClaimRepairability;
}

